// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"399":"css/admin-app.6900","8283":"css/app.6900"}[chunkId] + ".css";
};